import { createSlice } from '@reduxjs/toolkit';

const NAME = 'image';
const INITIAL_STATE = null;

const imageReducer = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        setActiveImage: (state, action) => {
            return {
                ...state,
                ...action.payload,
            };
        },
        clearActiveImage: () => {
            return INITIAL_STATE;
        },
    }
});

export const { setActiveImage, clearActiveImage } = imageReducer.actions;
export const selectImage = (state) => state.image;
export default imageReducer.reducer;
